
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const logoUrl = "/lovable-uploads/d62a4e07-f701-4335-84a0-c9be341a0477.png";
// Preload the logo image
const preloadImage = new Image();
preloadImage.src = logoUrl;

export const PaywallHeader = () => {
  const navigate = useNavigate();
  
  return (
    <>
      <Button
        variant="ghost"
        onClick={() => navigate("/login")}
        className="mb-8"
      >
        <ArrowLeft className="mr-2 h-4 w-4" />
        Back to Login
      </Button>

      <div className="max-w-4xl mx-auto text-center mb-16">
        <img 
          src={logoUrl}
          alt="Bright Stages" 
          className="h-24 md:h-32 mx-auto mb-8"
          loading="eager"
          decoding="async"
        />
        <h1 className="text-4xl font-bold text-gray-900 mb-6">
          Welcome to a Journey of Discovery!
        </h1>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-8">
          Unlock your child's potential with the only research-backed platform that tracks, supports, and celebrates growth with tailored guidance, progress reports, and meaningful milestones—supporting their unique journey.
        </p>

                <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-8">
          Special introductory pricing for new users.
            
            Regular Pricing:
$9.99/month | $59.88/year | $199.99 lifetime<br />
        </p>
      </div>
    </>
  );
};
